import React from 'react';

const FacilityDropdown = ({ name, value, onChange, className, required = false }) => {
  const fdleFacilities = [
    "Alachua County Jail",
    "Baker County Sheriff's Office",
    "Bay County Sheriff's Office Jail",
    "Bradford County Jail",
    "Brevard County Jail Complex",
    "Broward County Sherrif's Office - Joseph V. Conte Facility",
    "Broward County Sherrif's Office - Main Jail",
    "Broward County Sherrif's Office - North Broward Bureau",
    "Broward County Sherrif's Office - Paul Rein Detention Facility",
    "Calhoun County Jail",
    "Charlotte County Sheriff's Office Jail",
    "Clay County Sheriff's Office Jail/Detention",
    "Collier County Sheriff's Office - Immokalee Jail Center",
    "Collier County Sheriff's Office - Naples Jail Center",
    "Columbia County Detention Facility",
    "Citrus County Detention Facility",
    "DeSoto County Jail",
    "Dixie County Jail",
    "Escambia County Corrections",
    "Flagler County Sheriff's Office - Sheriff Perry Hall Inmate Detention Facility",
    "Franklin County Jail",
    "Gadsden County Detention Facility",
    "Gilchrist County Jail",
    "Glades County Jail Operations Center",
    "Gulf County Jail",
    "Hamilton County Jail",
    "Hardee County Sheriff's Office",
    "Hendry County Sheriff's Office",
    "Hernando County Detention Center",
    "Highlands County Sheriff's Office Detention Facility",
    "Hillsborough County Sheriff's Office - Falkenburg Road Jail",
    "Hillsborough County Sheriff's Office - Orient Road Jail",
    "Holmes County Jail",
    "Indian River County Jail",
    "Jackson County Correctional Facility",
    "Jacksonville Sheriff's Office - Community Transition Center",
    "Jacksonville Sheriff's Office - James I. Montgomery Correctional Center",
    "Jacksonville Sheriff's Office - John E. Goode Pre-trial Detention Facility",
    "Jefferson County Jail",
    "Lafayette County Jail",
    "Lake County Detention Center",
    "Lee County Sheriff's Office - Core Facility / CPU Compound",
    "Lee County Sheriff's Office - Main Jail",
    "Leon County Detention Facility",
    "Levy County Detention Center",
    "Liberty County Jail",
    "Madison County Jail",
    "Manatee County Correctional Complex - Annex",
    "Manatee County Correctional Complex - Central Jail",
    "Marion County Jail",
    "Martin County Corrections Department",
    "Metro West Detention Center",
    "Pre-Trial Detention Center",
    "Turner Guilford Knight Correctional Center",
    "Miami Dade County Boot Camp",
    "Monroe County Sheriff's Office, Detention Bureau",
    "Nassau County Detention Facility",
    "Okaloosa County Department of Corrections",
    "Okeechobee Coutny Sheriff's Office Jail",
    "Orange County Corrections Department",
    "Osceola County Corrections Facility",
    "Palm Beach County Sheriff's Office - Main Detention Center",
    "Palm Beach County Sheriff's Office - West Detention Center",
    "Pasco County Detention Center",
    "Pinellas County Jail",
    "Polk County Sheriff's Office - Central County Jail",
    "Polk County Sheriff's Office - South County Jail",
    "Putnam County Sheriff's Office",
    "Santa Rosa County Sheriff's Office - Main",
    "Santa Rosa County Sheriff's Office - Satellite",
    "Sarasota County Correctional Facility",
    "Seminole County Sheriff's Office - John E. Polk Correctional Facility",
    "Saint Lucie County Jail",
    "St. Johns County Detention Center",
    "Sumter County Jail",
    "Suwanee County Jail",
    "Taylor County Jail",
    "Test County Detention Facility",
    "Union County Jail",
    "Volusia County Branch Jail",
    "Volusia County Correctional Facility",
    "Wakulla County Sheriff's Office Detention Facility",
    "Walton County Jail",
    "Washington County Jail"
  ];

  return (
    <select
      name={name}
      value={value}
      onChange={onChange}
      className={className}
      required={required}
    >
      <option value="">Select Detention Facility</option>
      {fdleFacilities.map((facility, index) => (
        <option key={index} value={facility}>
          {facility}
        </option>
      ))}
    </select>
  );
};

export default FacilityDropdown;
